import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AppSumoPlan} from '../models/appsumo-settings.model';


@Injectable({
  providedIn: "root"
})
export class PlatformLifetimeCouponsService {

  constructor(private http: HttpClient) {

  }

  activateLifetimeCoupon(couponCode: string): Observable<any> {
    return this.http.post(
      environment.api.activatePlatformLifetimeCouponUrl,
      {
        couponCode
      });
  }

  activateMultiTierPlan(plan: AppSumoPlan, couponCodes: string[]): Observable<any> {
    return this.http.post(
      environment.api.activateMultiTierLifetimePlanUrl,
      {
        coupons: couponCodes,
        plan
      });
  }

}
